import { render, staticRenderFns } from "./DetailViewB2b.vue?vue&type=template&id=de241d7a&"
import script from "./DetailViewB2b.vue?vue&type=script&lang=js&"
export * from "./DetailViewB2b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports